/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.AccountingData = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The AccountingData model module.
   * @module model/AccountingData
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>AccountingData</code>.
   * @alias module:model/AccountingData
   * @class
   */
  var exports = function() {
    var _this = this;

























  };

  /**
   * Constructs a <code>AccountingData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountingData} obj Optional instance to populate.
   * @return {module:model/AccountingData} The populated <code>AccountingData</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ExternalID')) {
        obj['ExternalID'] = ApiClient.convertToType(data['ExternalID'], 'String');
      }
      if (data.hasOwnProperty('AccountNumber')) {
        obj['AccountNumber'] = ApiClient.convertToType(data['AccountNumber'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('Debet')) {
        obj['Debet'] = ApiClient.convertToType(data['Debet'], 'Number');
      }
      if (data.hasOwnProperty('Kredit')) {
        obj['Kredit'] = ApiClient.convertToType(data['Kredit'], 'Number');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('Dimension1')) {
        obj['Dimension1'] = ApiClient.convertToType(data['Dimension1'], 'String');
      }
      if (data.hasOwnProperty('Dimension2')) {
        obj['Dimension2'] = ApiClient.convertToType(data['Dimension2'], 'String');
      }
      if (data.hasOwnProperty('Dimension3')) {
        obj['Dimension3'] = ApiClient.convertToType(data['Dimension3'], 'String');
      }
      if (data.hasOwnProperty('Dimension4')) {
        obj['Dimension4'] = ApiClient.convertToType(data['Dimension4'], 'String');
      }
      if (data.hasOwnProperty('BookingDate')) {
        obj['BookingDate'] = ApiClient.convertToType(data['BookingDate'], 'Date');
      }
      if (data.hasOwnProperty('SegmentID')) {
        obj['SegmentID'] = ApiClient.convertToType(data['SegmentID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalSalesInvoiceID')) {
        obj['ExternalSalesInvoiceID'] = ApiClient.convertToType(data['ExternalSalesInvoiceID'], 'Integer');
      }
      if (data.hasOwnProperty('DebetCumulative')) {
        obj['DebetCumulative'] = ApiClient.convertToType(data['DebetCumulative'], 'Number');
      }
      if (data.hasOwnProperty('KreditCumulative')) {
        obj['KreditCumulative'] = ApiClient.convertToType(data['KreditCumulative'], 'Number');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('Dimension5')) {
        obj['Dimension5'] = ApiClient.convertToType(data['Dimension5'], 'String');
      }
      if (data.hasOwnProperty('Dimension6')) {
        obj['Dimension6'] = ApiClient.convertToType(data['Dimension6'], 'String');
      }
      if (data.hasOwnProperty('TransactionTypeID')) {
        obj['TransactionTypeID'] = ApiClient.convertToType(data['TransactionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('YTDCumulativeValueDebet')) {
        obj['YTDCumulativeValueDebet'] = ApiClient.convertToType(data['YTDCumulativeValueDebet'], 'Number');
      }
      if (data.hasOwnProperty('YTDCumulativeValueKredit')) {
        obj['YTDCumulativeValueKredit'] = ApiClient.convertToType(data['YTDCumulativeValueKredit'], 'Number');
      }
      if (data.hasOwnProperty('DataDimensionID')) {
        obj['DataDimensionID'] = ApiClient.convertToType(data['DataDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('ForecastModelRecordDataID')) {
        obj['ForecastModelRecordDataID'] = ApiClient.convertToType(data['ForecastModelRecordDataID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} ExternalID
   * @default ''
   */
  exports.prototype['ExternalID'] = '';
  /**
   * @member {Integer} AccountNumber
   * @default 0
   */
  exports.prototype['AccountNumber'] = 0;
  /**
   * @member {Integer} CompanyLegalEntityID
   * @default 0
   */
  exports.prototype['CompanyLegalEntityID'] = 0;
  /**
   * @member {Number} Debet
   * @default 0.0
   */
  exports.prototype['Debet'] = 0.0;
  /**
   * @member {Number} Kredit
   * @default 0.0
   */
  exports.prototype['Kredit'] = 0.0;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} Dimension1
   * @default ''
   */
  exports.prototype['Dimension1'] = '';
  /**
   * @member {String} Dimension2
   * @default ''
   */
  exports.prototype['Dimension2'] = '';
  /**
   * @member {String} Dimension3
   * @default ''
   */
  exports.prototype['Dimension3'] = '';
  /**
   * @member {String} Dimension4
   * @default ''
   */
  exports.prototype['Dimension4'] = '';
  /**
   * @member {Date} BookingDate
   */
  exports.prototype['BookingDate'] = undefined;
  /**
   * @member {Integer} SegmentID
   */
  exports.prototype['SegmentID'] = undefined;
  /**
   * @member {Integer} ExternalSalesInvoiceID
   */
  exports.prototype['ExternalSalesInvoiceID'] = undefined;
  /**
   * @member {Number} DebetCumulative
   */
  exports.prototype['DebetCumulative'] = undefined;
  /**
   * @member {Number} KreditCumulative
   */
  exports.prototype['KreditCumulative'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {String} Dimension5
   * @default ''
   */
  exports.prototype['Dimension5'] = '';
  /**
   * @member {String} Dimension6
   * @default ''
   */
  exports.prototype['Dimension6'] = '';
  /**
   * @member {Integer} TransactionTypeID
   * @default 0
   */
  exports.prototype['TransactionTypeID'] = 0;
  /**
   * @member {Number} YTDCumulativeValueDebet
   */
  exports.prototype['YTDCumulativeValueDebet'] = undefined;
  /**
   * @member {Number} YTDCumulativeValueKredit
   */
  exports.prototype['YTDCumulativeValueKredit'] = undefined;
  /**
   * @member {Integer} DataDimensionID
   * @default 0
   */
  exports.prototype['DataDimensionID'] = 0;
  /**
   * @member {Integer} ForecastModelRecordDataID
   */
  exports.prototype['ForecastModelRecordDataID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


